import { CascadiaProvider } from "@certn/cascadia-react";
import { APIProvider } from "@certn/legacy-api";
import Cookies from "js-cookie";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { Debug } from "./debug";
import { getDomain } from "./utils";

interface Props {
  children: React.ReactNode;
}

export function Providers({ children }: Props) {
  const [token, setToken] = useState<string | null>(
    Cookies.get("token") || null
  );
  const { i18n } = useTranslation();

  const clearToken = useCallback(() => {
    Cookies.remove("token");
    setToken(null);
  }, [setToken]);

  return (
    <CascadiaProvider locale={i18n.language}>
      <APIProvider
        domain={getDomain()}
        token={token}
        setToken={(token) => {
          Cookies.set("token", token);
          setToken(token);
        }}
        clearToken={clearToken}
      >
        {children}
        <Debug />
      </APIProvider>
    </CascadiaProvider>
  );
}
